import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataPatientEssential extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().patient_home_patient_id, value: StringUtils.formatStringOrNoData(data.PatientIdNum, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_first_name, value: StringUtils.formatStringOrNoData(data.FirstName, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_last_name, value: StringUtils.formatStringOrNoData(data.LastName, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_date_of_birth, value: StringUtils.formatUtcDateOrNoData(data.DOB, CurrentLang().no_data, false) },
            { name: CurrentLang().patient_clinic, value: StringUtils.formatStringOrNoData(data.Clinic, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_gender_label, value: StringUtils.formatStringOrNoData(data.Gender, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_contact_number_label, value:  StringUtils.formatStringOrNoData(data.Phone, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_address_label, value: StringUtils.formatStringOrNoData(data.Address, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_country_label, value: StringUtils.formatStringOrNoData(data.Country, CurrentLang().no_data) },
            { name: CurrentLang().edit_patient_zip_label, value: StringUtils.formatStringOrNoData(data.PostalCode, CurrentLang().no_data) },
            { name: CurrentLang().patient_status, value: StringUtils.formatStringOrNoData(data.Status, CurrentLang().no_data) },
           ]
        
        return tableData;
    }
}

export default MagstimTableDataPatientEssential;
